import { configure } from "mobx";

configure({ isolateGlobalState: true });
